import { all, call, delay, put, takeLatest } from 'redux-saga/effects';

import api from '../../../core/api';
import { getFarmsListRequest } from '../farms/farms.actions';
import * as actions from './code.actions';
import { composeErrorMessage } from '../../../core/helpers/utils/utils';
import { notificationError } from '../../../core/helpers/utils/notificationUtils';

export function* getCodeListSaga() {
  try {
    const result = yield call(api.code.getCodeList, true);

    yield put(
      actions.getCodeList.done({
        params: {},
        result,
      }),
    );
  } catch (err) {
    yield put(notificationError(composeErrorMessage(err)));
  }
}

export function* getCodeListWithDelaySaga() {
  yield delay(300000);
  yield getCodeListSaga();
}

export function* watchCodeSaga() {
  yield all([
    takeLatest(actions.getCodeList.started, getCodeListSaga),
    takeLatest(getFarmsListRequest.done, getCodeListSaga),
    takeLatest(actions.getCodeListWithDelay.started, getCodeListWithDelaySaga),
  ]);
}
